export default __webpack_public_path__ + "static/download-apple-9359d5f5da01a27461c1db462ff9f510.svg";